<!--
	@name app-firm-dialog-edit-trading-style
	@description Show a dialog to edit a trading style
	@date 2020/08/26
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<common-dialog ref="dialog" :component="$options.name" :max-width="500">
		<template #header>
			Edit Trading Style
		</template>

		<template #body>
			<dynamic-form
				ref="dynamicForm"
				:submit-button-text="'Edit Trading Style'"
				:form-schema="form"
				:form-data="formData"
				:submit-button-loading="submitting"
				@dynamic-form-submit="editTradingStyle"
			/>
		</template>
	</common-dialog>
</template>

<script>
	import { mapActions, mapState } from 'vuex';
	import { ElementTools } from '@/utils';
	import CommonDialog from '@/component/common/dialog';
	import DynamicForm from '@/component/common/base/dynamic-form';

	export default {
		name: 'app-firm-dialog-edit-trading-style',

		components: { CommonDialog, DynamicForm },

		props: {
			form: { type: Array, required: true, default: () => [] }
		},

		data() {
			return {
				submitting: false,
				formData: {},
				tradingStyle: null
			};
		},

		computed: {
			...mapState('Account', ['organisation'])
		},

		methods: {
			...mapActions('AccountOrganisationTradingStyle', ['modifyOrganisationTradingStyle']),

			/**
			 * @name editTradingStyle
			 * @description Sends request to edit a trading style
			 */
			async editTradingStyle() {
				this.submitting = true;

				this.modifyOrganisationTradingStyle({
					id: this.tradingStyle.id,
					payload: {
						name: this.formData.name,
						data: {
							fca: this.formData.fca
						}
					}
				})
					.then(() => {
						ElementTools.fireNotification(this.$el, 'success', 'Trading style has been updated successfully');
						this.$refs.dialog.close();
					})
					.catch((e) => {
						let message = 'Failed to edit trading style';
						if (e.data.message === 'Cannot duplicate a unique value, value already exists') message = 'Trading style already exists for the firm';
						ElementTools.fireNotification(this.$el, 'error', message);
					})
					.finally(() => (this.submitting = false));
			},

			/**
			 * @name open
			 * @description Open dialog and set properties
			 */
			open(tradingStyle) {
				this.tradingStyle = tradingStyle;
				this.formData = {
					name: tradingStyle.name,
					fca: tradingStyle.data?.fca,
					editFCA: this.organisation.data?.tradingStyles?.editFCA
				};
				this.$refs.dialog.open();
			}
		}
	};
</script>
